import { GetContentsQuery } from '@diritto/common/api/RelayContentApi';
import { CONTENT_LIST_PAGE_ITEM_COUNT } from '@diritto/common/content/constants';
import { ContentListRelayResponseDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { RelayContentApi } from 'api/ApiHelper';
import { AxiosRequestConfig } from 'axios';
import { contentsQueryKey } from 'queries/contents/queryKey';
import { QueryClient, useInfiniteQuery } from '@tanstack/react-query';

const getNextPageParam = (lastGroup: ContentListRelayResponseDto, allGroups: ContentListRelayResponseDto[]) => {
  if ((lastGroup.contentIds?.length ?? 0) < CONTENT_LIST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + (current.contentIds?.length ?? 0), 0);
};

export const useGetRelayContentsInfiniteQuery = (query: GetContentsQuery) =>
  useInfiniteQuery({
    queryKey: contentsQueryKey.contentList(query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getContents({
        offset: pageParam,
        limit: CONTENT_LIST_PAGE_ITEM_COUNT,
        ...query,
      }),
    initialPageParam: 0,
    getNextPageParam,
  });

export const prefetchRelayContentsQuery = (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  query: GetContentsQuery,
) =>
  queryClient.prefetchInfiniteQuery({
    queryKey: contentsQueryKey.contentList(query),
    queryFn: ({ pageParam = 0 }) =>
      RelayContentApi.getContents(
        {
          offset: pageParam,
          limit: CONTENT_LIST_PAGE_ITEM_COUNT,
          ...query,
        },
        options,
      ),
    initialPageParam: 0,
    getNextPageParam,
  });
